import { useQuery } from '@tanstack/react-query'

import { getSessionIdFromLocalStorage } from 'src/localStorage/sessionId/getSessionIdFromLocalStorage/getSessionIdFromLocalStorage'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { getInvoices } from 'src/services/subscriptionApi'
import { InvoicesResponse } from 'src/services/subscriptionApi/interfaces/subscriptionApi.interface'

export const useGetInvoicesQuery = () => {
  const sessionId = getSessionIdFromLocalStorage()

  return useQuery<InvoicesResponse>({
    enabled: !!sessionId,
    queryFn: getInvoices,
    queryKey: [QueryKey.GET_INVOICES],
  })
}
